import { Field, Form } from 'formik'
import { FC } from 'react'
import { CompanyOrderBase, CompanyOrderFieldBase } from '@/types'
import { KeywordSearchGroupFormSortOrderForCompanies } from '@components-v2/molecules/KeywordSearchGroupFormSortOrderForCompanies'
import { useTranslation } from 'next-i18next'
import { SearchInputFieldGroup } from '@components-v2/molecules/SearchInputFieldGroup'
import { Button2 } from '@/componentsV2/atoms/Button2'
import styles from './index.module.scss'

type Props = {
  isVc?: boolean
  selectedCompanyOrder: CompanyOrderBase
  setCompanyOrderField?: (companyOrderField: CompanyOrderFieldBase) => void
  isSubmitting: boolean
}

export const KeywordSearchGroupFormForCompanies: FC<Props> = ({
  children,
  isVc = false,
  selectedCompanyOrder,
  setCompanyOrderField,
  isSubmitting,
}) => {
  const { t } = useTranslation(['angels-vcs-startups'])

  return (
    <Form>
      <div className={styles.searchContainer}>
        <div className={styles.keywordGroup}>
          <Field
            name='keyword'
            type='text'
            fieldType='search'
            placeholder={t('キーワードを入力')}
            component={SearchInputFieldGroup}
          />
          <Button2 disabled={isSubmitting} isLoading={isSubmitting} hierarchy='primary' size='xl' buttonType='submit'>
            {t('検索する')}
          </Button2>
        </div>
        <div className={styles.advancedSearchContainer}>{children}</div>
      </div>
      <KeywordSearchGroupFormSortOrderForCompanies
        isVc={isVc}
        selectedValue={selectedCompanyOrder}
        setFieldValue={setCompanyOrderField}
      />
    </Form>
  )
}
